/**
 * businessReportList 日度：前端直调 PMS，按店缓存 1 天，多组件（房态健康、客源、折扣、渠道分析/信息、出租率、运营效率）共用
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getBusinessReportListFromThirdParty } from '../../service/storeRevenueApi';
import { formatDateInChina, getYesterdayStrInChina } from '../../utils/dateChina';
import { setStoreSliceInLocalStorage } from './storeRevenueLocalStorage';
var TTL_MS = 24 * 60 * 60 * 1000; // 1 天
var memoryCache = new Map();
var inFlight = new Map();
var memoryCacheMonthly = new Map();
var inFlightMonthly = new Map();
function cacheKey(storeId) {
    var endStr = getYesterdayStrInChina();
    return "businessReportDaily:".concat(String(storeId), ":").concat(endStr);
}
function cacheKeyMonthly(storeId) {
    var endStr = getYesterdayStrInChina();
    return "businessReportMonthly:".concat(String(storeId), ":").concat(endStr);
}
function isValid(entry) {
    return Date.now() - entry.fetchedAt < TTL_MS;
}
/** 接口只支持到上一营业日：查询填上一营业日及前 365 天 */
function getDailyRangeInChina() {
    var endDateStr = getYesterdayStrInChina();
    var yesterdayStart = new Date("".concat(endDateStr, "T00:00:00+08:00"));
    var startDate = new Date(yesterdayStart.getTime() - 365 * 86400 * 1000);
    var startDateStr = formatDateInChina(startDate);
    return { startDate: startDateStr, endDate: endDateStr };
}
/**
 * 按店获取日度 businessReportList，带内存 + localStorage 缓存，1 天有效；同店并发只发一次请求
 */
export function getBusinessReportDailyWithCache(storeId) {
    return __awaiter(this, void 0, Promise, function () {
        var key, entry, existing, _a, startDate, endDate, promise;
        return __generator(this, function (_b) {
            key = cacheKey(storeId);
            entry = memoryCache.get(key);
            if (entry && isValid(entry)) {
                return [2 /*return*/, entry.list];
            }
            existing = inFlight.get(key);
            if (existing)
                return [2 /*return*/, existing];
            _a = getDailyRangeInChina(), startDate = _a.startDate, endDate = _a.endDate;
            promise = getBusinessReportListFromThirdParty(storeId, {
                dateType: 0,
                startDate: startDate,
                endDate: endDate,
                pageNum: 1,
                pageSize: 500,
            })
                .then(function (list) {
                var fetchedAt = Date.now();
                var cacheEntry = { list: list, fetchedAt: fetchedAt, startDate: startDate, endDate: endDate };
                memoryCache.set(key, cacheEntry);
                setStoreSliceInLocalStorage(storeId, 'businessReportDaily', {
                    data: { list: list, startDate: startDate, endDate: endDate },
                    fetchedAt: fetchedAt,
                });
                return list;
            })
                .finally(function () {
                inFlight.delete(key);
            });
            inFlight.set(key, promise);
            return [2 /*return*/, promise];
        });
    });
}
/**
 * 按店获取月度 businessReportList（dateType=1），用于「过去12个月」；带内存缓存，1 天有效
 */
export function getBusinessReportMonthlyWithCache(storeId) {
    return __awaiter(this, void 0, Promise, function () {
        var key, entry, existing, _a, startDate, endDate, promise;
        return __generator(this, function (_b) {
            key = cacheKeyMonthly(storeId);
            entry = memoryCacheMonthly.get(key);
            if (entry && isValid(entry)) {
                return [2 /*return*/, entry.list];
            }
            existing = inFlightMonthly.get(key);
            if (existing)
                return [2 /*return*/, existing];
            _a = getDailyRangeInChina(), startDate = _a.startDate, endDate = _a.endDate;
            promise = getBusinessReportListFromThirdParty(storeId, {
                dateType: 1,
                startDate: startDate,
                endDate: endDate,
                pageNum: 1,
                pageSize: 500,
            })
                .then(function (list) {
                var fetchedAt = Date.now();
                var cacheEntry = { list: list, fetchedAt: fetchedAt, startDate: startDate, endDate: endDate };
                memoryCacheMonthly.set(key, cacheEntry);
                return list;
            })
                .finally(function () {
                inFlightMonthly.delete(key);
            });
            inFlightMonthly.set(key, promise);
            return [2 /*return*/, promise];
        });
    });
}
/** 从 localStorage 恢复日度 list（冷启动），仅当 key 对应「今天」且未过期时返回 */
export function getBusinessReportDailyFromLocalStorage(storeId) {
    var _a;
    try {
        var key = "ms_store_revenue_store_".concat(String(storeId));
        var raw = localStorage.getItem(key);
        if (!raw)
            return null;
        var parsed = JSON.parse(raw);
        if ((parsed === null || parsed === void 0 ? void 0 : parsed.version) !== 1 || !((_a = parsed.sources) === null || _a === void 0 ? void 0 : _a.businessReportDaily))
            return null;
        var slice = parsed.sources.businessReportDaily;
        var list = (slice === null || slice === void 0 ? void 0 : slice.data) && typeof slice.data === 'object' && Array.isArray(slice.data.list)
            ? slice.data.list
            : null;
        if (!list || !slice.fetchedAt)
            return null;
        if (Date.now() - slice.fetchedAt >= TTL_MS)
            return null;
        var endStr = getYesterdayStrInChina();
        var memoryKey = "businessReportDaily:".concat(String(storeId), ":").concat(endStr);
        memoryCache.set(memoryKey, { list: list, fetchedAt: slice.fetchedAt, startDate: '', endDate: '' });
        return list;
    }
    catch (_b) {
        return null;
    }
}
/** 清除某店日度/月度缓存（刷新时） */
export function clearBusinessReportDailyCache(storeId) {
    if (storeId != null) {
        var endStr = getYesterdayStrInChina();
        memoryCache.delete("businessReportDaily:".concat(String(storeId), ":").concat(endStr));
        memoryCacheMonthly.delete("businessReportMonthly:".concat(String(storeId), ":").concat(endStr));
        return;
    }
    memoryCache.clear();
    inFlight.clear();
    memoryCacheMonthly.clear();
    inFlightMonthly.clear();
}
/** 开发环境：控制台通过 window.__storeRevenueCaches.operationAnalysis 查看日度缓存 */
export function __getBusinessReportDailyCacheForDev() {
    return memoryCache;
}
